<template>
    <b-modal v-model="show" :no-close-on-esc="true" :no-close-on-backdrop="true" size="xl">
        <div slot="modal-header" class="w-100">
            <div class="row">
                <div class="col-md-6">
                    <b><span class="text-success">{{$t("auto.autoCalculationLabel")}}</span></b>
                </div>
                <div class="col-md-6">
                    <b>Машина қурилмалари емирилиш фоизи <span class="text-success">&nbsp;&nbsp;{{autoDto.losesDilapidationValue}} %</span></b>
                </div>
            </div>
        </div>
        <div class="container-fluid pl-0 pr-0" style="height: 500px; overflow-y: scroll">
            <div class="row">
                <div class="col-12 table-responsive">
                  <div class="table-wrapper">
                    <table class="table table-bordered text-center">
                        <tr class="font-weight-bold">
                            <td width="25%">Қурилма номи<code>*</code></td>
                            <td width="10%">Миқдори<code>*</code></td>
                            <td>Тури</td>
                            <td>Норма соати</td>
                            <td class="font-weight-bold" style="color: green;">Умумий нархлар</td>
                            <td class="font-weight-bold" style="color: green;">Умумий нарх</td>
                            <td width="30px">Қўшимча</td>
                        </tr>
                        <tr v-for="(autoDefect, index) in autoDto.autoDefectActs" :key="autoDefect.id">
                            <td>
                                <v-select v-model="autoDefect.autoPartsNormHoursDto"
                                          :options="autoParts"
                                          @search="onAutoPartsSearch"
                                          @search:focus="onAutoPartsFocus"
                                          label="autoPartsDto"
                                          @change="changePrices(autoDefect)"
                                >
                                    <template slot="option" slot-scope="option" v-if="option">
                                        <div v-html="option.autoPartsDto.name"></div>
                                    </template>

                                    <template slot="selected-option" v-if="autoDefect && autoDefect.autoPartsNormHoursDto &&
                                                      autoDefect.autoPartsNormHoursDto.autoPartsDto && autoDefect.autoPartsNormHoursDto.autoPartsDto.name">
                                        <div v-html="autoDefect.autoPartsNormHoursDto.autoPartsDto.name"
                                             @click="$eventBus.$emit('search:focus')"
                                        >
                                        </div>
                                    </template>
                                    <span slot="no-options">{{$t("empty")}}</span>
                                </v-select>
                                <div class="red"
                                     v-if="$v.autoDto.autoDefectActs.$each[index].autoPartsNormHoursDto.autoPartsDto.$error">
                                    Қурилма номи
                                </div>
                            </td>
                            <td>
                                <numeric-input class="form-control" v-model="autoDefect.qty"
                                               :class="{invalid : $v.autoDto.autoDefectActs.$each[index].qty.$error}"
                                               :controls="false" :precision="0"
                                               @input="changePrices(autoDefect)"></numeric-input>
                                <div class="red" v-if="$v.autoDto.autoDefectActs.$each[index].qty.$error">
                                    Миқдори
                                </div><br/>
                                <span class="font-weight-bold" style="color: green;">
                                    {{autoDefect.autoPartsNormHoursDto.price | currency('', 0, { thousandsSeparator: ' ' })}}
                                </span>
                            </td>
                            <td>
                                <div>
                                    <i>Таъмирлаш</i><br/>
                                    <input type="radio"
                                           v-model="autoDefect.typeOfFix"
                                           value="Repair"
                                           required
                                           @change="changePrices(autoDefect)"/>
                                    <br/>
                                    <i>Алмаштириш</i><br/>
                                    <input type="radio"
                                           v-model="autoDefect.typeOfFix"
                                           value="Upgrade"
                                           required
                                           @change="changePrices(autoDefect)"/>
                                </div>
                            </td>
                            <td class="text-center">
                                <span v-if="autoDefect.typeOfFix === 'Upgrade'">
                                    {{autoDefect.autoPartsNormHoursDto.normHourUpgrade}}
                                </span>
                                <span v-else-if="autoDefect.typeOfFix === 'Repair'">
                                    {{autoDefect.autoPartsNormHoursDto.normHourRepair}}
                                </span><br/>
                                <span class="font-weight-bold" style="color: green;">
                                    {{autoDefect.price | currency('', 0, { thousandsSeparator: ' ' })}}
                                </span>
                            </td>
                            <td class="text-center">
                                <span class="font-weight-bold">
                                    Янги қурилма
                                </span><br/>
                                <span class="font-weight-bold" style="color: green;">
                                    {{autoDefect.totalAmountOfNewSoldParts | currency('', 0, { thousandsSeparator: ' ' })}}
                                </span><br/>
                                <span class="font-weight-bold">
                                    Қўшимча харажатлар
                                </span><br/>
                                <span class="font-weight-bold" style="color: green;">
                                    {{autoDefect.totalAmountOfSmallParts | currency('', 0, { thousandsSeparator: ' ' })}}
                                </span><br/>
                                <span class="font-weight-bold">
                                    Уста ҳақи
                                </span><br/>
                                <span class="font-weight-bold" style="color: green;">
                                    {{autoDefect.totalAmountOfFixingParts | currency('', 0, { thousandsSeparator: ' ' })}}
                                </span>
                            </td>
                            <td class="text-center">
                                <span class="font-weight-bold" style="color: green;">
                                    {{autoDefect.totalAmountOfDefectAct | currency('', 0, { thousandsSeparator: ' ' })}}
                                </span>
                            </td>
                            <td style="white-space: nowrap">
                                <button type="button" class="all-btn add-btn" title="Қўшимча харажатлар"
                                        v-if="autoDefect.typeOfFix === 'Repair'" @click="addSmallParts(autoDefect)">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>Жами </b>
                            </td>
                            <td colspan="4">

                            </td>
                            <td>
                                <b><span class="text-success">{{autoDto.evlPrice | currency('', 0, { thousandsSeparator: ' ' })}}</span></b>
                            </td>
                            <td><b><span class="text-success">сўм</span></b></td>
                        </tr>
                    </table>
                  </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3">
            <button class="all-btn float-left ml-3" @click="cancel">
                Ёпиш
            </button>
            <button class="all-btn add-btn float-right" v-if="canSave && canEvaluate" @click="evaluate">
                Бахолаш
            </button>
        </div>
        <SmallParts/>
    </b-modal>
</template>

<script>

    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import initFilterModel from '@/shared/filter';
    import {required, minValue} from 'vuelidate/lib/validators';
    import SmallParts from '@/views/auto/SmallParts';

    export default {
        name: "DefectAct",
        components: {
            'b-modal': bModal,
            SmallParts
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                autoPartFilter: initFilterModel(),
                autoDto: {
                    evlPrice: 0
                },
                autoParts: []
            }
        },
        validations() {
            return {
                autoDto: {
                    autoDefectActs: {
                        $each: {
                            autoPartsNormHoursDto: {
                                autoPartsDto: {
                                    required: required
                                }
                            },
                            qty: {
                                required: required,
                                minValue: minValue(1)
                            }
                        }
                    }
                }
            }
        },
        computed: {
            canSave() {
                return (this.autoDto.parentAppraisalStatusEnum === 'Unreviewed' || this.autoDto.parentAppraisalStatusEnum === 'NotFullyEvaluated');
            },
            canEvaluate() {
                return this.hasPermission('NEW_AUTO_LOSES_EDIT') && this.autoDto.parentAppraisalStatusEnum === 'Unreviewed' && !this.autoDto.hasAppraiserReportEsp;
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },
            init() {
                const vm = this;
                this.$http.get('auto/item/' + this.autoId).then(function (data) {
                    vm.autoDto = data.data;
                });
            },
            evaluate() {
                const vm = this;
                vm.$http.post('auto/damage/save', vm.autoDto).then(function (data) {
                    vm.$swal({
                        title: data.data.status !== 'SUCCESS' ? vm.$t('messages.common.warning') : vm.$t('messages.common.success'),
                        text: data.data.status !== 'SUCCESS' ? vm.$t(data.data.message) : vm.$t('auto.success'),
                        type: data.data.status !== 'SUCCESS' ? 'warning' : 'success'
                    });
                    if (data.data.status === 'SUCCESS') {
                        window.location.reload();
                    }
                });
            },
            onAutoPartsSearch(searchTxt, loading) {
                if (!this.autoDto.autoTypeDto.id) {
                    return;
                }
                loading(true);
                this.autoPartFilter.search = searchTxt;
                this.autoPartFilter.parentId = this.autoDto.autoTypeDto.id;
                this.searchMethod(loading);
            },
            onAutoPartsFocus() {
                if (!this.autoDto.autoTypeDto.id) {
                    return;
                }
                this.autoPartFilter.search = '';
                this.autoPartFilter.parentId = this.autoDto.autoTypeDto.id;
                this.searchMethod();
            },
            searchMethod(loading) {
                this.autoParts = [];
                this.$http.post('auto-part/search-by-auto', this.autoPartFilter)
                    .then(res => {
                        if (loading)
                            loading(false);
                        this.autoParts = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            changePrices(autoDefect) {
                if (autoDefect.typeOfFix === 'Upgrade') {
                    autoDefect.totalAmountOfNewSoldParts = autoDefect.qty * autoDefect.autoPartsNormHoursDto.price;
                    autoDefect.totalAmountOfNewSoldParts = autoDefect.totalAmountOfNewSoldParts * ((100 - this.autoDto.losesDilapidationValue) / 100);

                    autoDefect.totalAmountOfFixingParts = autoDefect.qty * autoDefect.autoPartsNormHoursDto.normHourUpgrade * autoDefect.price;
                    autoDefect.totalAmountOfSmallParts = 0;
                } else if (autoDefect.typeOfFix === 'Repair') {
                    autoDefect.totalAmountOfNewSoldParts = 0;
                    autoDefect.totalAmountOfFixingParts = autoDefect.qty * autoDefect.autoPartsNormHoursDto.normHourRepair * autoDefect.price;
                    this.calculateSmallTotalPrice(autoDefect);
                }
                autoDefect.totalAmountOfDefectAct = autoDefect.totalAmountOfNewSoldParts + autoDefect.totalAmountOfFixingParts + autoDefect.totalAmountOfSmallParts;
                autoDefect.changedDefectAct = true;
                this.calculateTotalPrice();
            },
            calculateTotalPrice() {
                this.autoDto.evlPrice = 0;
                this.autoDto.autoDefectActs.forEach((act) => {
                    this.autoDto.evlPrice += act.totalAmountOfDefectAct;
                });
            },
            calculateSmallTotalPrice(autoDefect) {
                autoDefect.totalAmountOfSmallParts = 0;
                autoDefect.smallAutoPartsItemDtos.forEach((small) => {
                    autoDefect.totalAmountOfSmallParts += small.amount;
                });
            },
            addSmallParts(autoDefect) {
                this.$eventBus.$emit('SmallParts', autoDefect);
            }
        },
        created() {
            this.$eventBus.$on('DefectAct', (autoId) => {
                this.show = true;
                this.autoId = autoId;
                if (autoId) {
                    this.init()
                }
            });

            this.$eventBus.$on('DefectActSmallPart', (autoDefect) => {
                this.changePrices(autoDefect);
            });
        }
    }
</script>

<style scoped>

</style>